import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 招标采购信息
 */
export default {
  path: 'public-tender',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '招标采购信息',
    icon: 'icon-side_supplier_notice',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
    { companyType: companyTypeDict.SELF_EMPLOYEE.value },
    { companyType: companyTypeDict.PERSON.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 信息列表
    {
      path: 'list',
      name: 'PublicTenderList',
      component: '/supplier-views/public-tender/public-tender-list',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '信息列表',
        cache: true,
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
